<div class="header d-flex flex-row">
    <a target="_blank" href="https://www.edp.pt/particulares/" rel="noopener noreferrer">
        <img src="assets/images/stella-images/edp_logo_rgb_dark_neg.svg" alt="Edp">
    </a>
</div>
